import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { headerLogo } from './constants/header.constants';
import { AuthService } from '../../services/auth.service';
import { HeaderLoginNavComponent } from './header-login-nav/header-login-nav.component';
import { HeaderSideNavComponent } from './header-side-nav/header-side-nav.component';
import { HeaderHeroType, HeaderVariant } from './header.types';
import { LibConfig } from '../../models/lib-config.model';
import { LIB_CONFIG } from '../../lib-config';

@Component({
  selector: 'vm-header-wrapper',
  templateUrl: './header-wrapper.component.html',
  styleUrls: ['./header-wrapper.component.scss'],
})
export class HeaderWrapperComponent implements OnInit {
  @ViewChild('loginNav') loginNav: HeaderLoginNavComponent;
  @ViewChild('sideNav') sideNav: HeaderSideNavComponent;

  @Input() variant: HeaderVariant = HeaderVariant.secondary;
  @Input() heroType: HeaderHeroType | null = null;
  @Input() containsHero = false;
  @Input() containsSideNav = true;
  @Input() containsLoginNav = true;

  headerVariant = HeaderVariant;
  isAuthenticated = false;
  headerLogo = headerLogo;

  constructor(private authService: AuthService, @Inject(LIB_CONFIG) private config: LibConfig) {}

  ngOnInit(): void {
    const checkAuthentcation = setInterval(() => {
      this.isAuthenticated = this.authService.isAuthenticated();
      if (this.isAuthenticated) {
        clearInterval(checkAuthentcation);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(checkAuthentcation);
    }, 500);
  }

  toggleLoginNav() {
    this.loginNav?.toggleLoginNav();
  }

  toggleSideNav() {
    this.sideNav?.toggleSideNav();
  }
}
